import { ITurmaDis } from "@deltasge/marauders-map";
import { Button, DialogActions, DialogContent, TextField } from "@mui/material";
import React, { FC, useState } from "react";

export const DialogTurmaDescritiva: FC<{
  onClose: (descricao: string) => void;
  turmaDis: ITurmaDis;
}> = ({ onClose, turmaDis }) => {
  const [descricao, setDescricao] = useState(turmaDis.descricao ?? "");
  return (
    <>
      <DialogContent dividers style={{ paddingBottom: 0 }}>
        <TextField
          label="Objetivo da matéria"
          multiline
          minRows={5}
          size="small"
          inputProps={{
            style: { height: "100%", overflow: "auto", fontSize: "14px" },
          }}
          value={descricao}
          sx={{
            width: "100%",
            maxHeight: "100%",
            height: "100%",
            overflow: "hidden",
            flexDirection: "row",
          }}
          onChange={({ target: { value } }) => setDescricao(value)}
        />
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => onClose(descricao)}
          variant="text"
          color="inherit"
        >
          Fechar
        </Button>
      </DialogActions>
    </>
  );
};
